import axios from '@/http/index';

const base = '';
// 赊账列表
export const getGzlb = (params) => axios.get(`${base}/erp/account/getAccountList`, params).then((res) => res.data);
// 总还款记录列表
export const getZhkjl = (params) => axios.get(`${base}/erp/account/toAccountRefundItem`, params).then((res) => res.data);
